import React from "react";
import styled, { css } from "styled-components";

import PropTypes from "prop-types";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// hooks
import { useScrollBarWidth } from "frontend/hooks/useScrollBarWidth.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";

// Constants used by ScrollToPinned and shared with positioning calculations
export const SCROLL_TO_PINNED_PADDING = 18; // px
export const SCROLL_TO_PINNED_BORDER_WIDTH = 1; // px

/**
 * ScrollPlaceholder (Placeholder)
 * This ensures the content below header scrolls naturally
 * As upper positioned fix layers will not
 */
const ScrollPlaceholderStyled = styled.header`
    text-align: center;
    height: ${convertPxToRem(128)};

    /* Light Mode */
    background-color: transparent;

    /* Dark Mode */
    ${({ $isDarkMode }) => {
        if ($isDarkMode) {
            return css`
                background-color: ${colors.secondary.orca};
            `;
        }
    }}
`;

/**
 * ScrollToPinned
 * This will scroll based on window.scollY range, not every page uses the same range see core/SiteHeader/context/getHeaderProps.js
 */
const ScrollToPinnedStyled = styled.div`
    position: fixed;
    left: 0px;
    right: ${({ $right }) => $right};
    z-index: 1000;
    padding: ${convertPxToRem(SCROLL_TO_PINNED_PADDING)};

    /* Light Mode */
    background-color: ${colors.primary.snow};
    border-bottom: solid ${convertPxToRem(SCROLL_TO_PINNED_BORDER_WIDTH)}
        ${colors.primary.scheifer};

    /* Dark Mode */
    ${({ $isDarkMode }) => {
        if ($isDarkMode) {
            return css`
                background-color: ${colors.secondary.orca};
                border-bottom: solid
                    ${convertPxToRem(SCROLL_TO_PINNED_BORDER_WIDTH)}
                    ${colors.secondary.orca};
            `;
        }
    }}

    ${({ $top, $paddingBottom }) => {
        return css`
            top: ${convertPxToRem($top)};
            padding-bottom: ${convertPxToRem($paddingBottom)};
        `;
    }}
`;

const ScrolledToPinnedInnerStyled = styled.div`
    width: 100%;
    max-width: ${convertPxToRem(1366)};
    margin: 0px auto;
`;

// component
export const ScrollToPinned = ({ children }) => {
    const {
        hamburgerModalIsOpen,
        header: { top, paddingBottom },
        isDarkMode
    } = useSiteHeader();

    const { scrollbarWidthRem } = useScrollBarWidth();

    const right = hamburgerModalIsOpen ? scrollbarWidthRem : "0rem";

    return (
        <ScrollPlaceholderStyled $isDarkMode={isDarkMode}>
            <ScrollToPinnedStyled
                $isDarkMode={isDarkMode}
                $top={top}
                $paddingBottom={paddingBottom}
                $right={right}
            >
                <ScrolledToPinnedInnerStyled>
                    {children}
                </ScrolledToPinnedInnerStyled>
            </ScrollToPinnedStyled>
        </ScrollPlaceholderStyled>
    );
};

export default ScrollToPinned;

// prop-types
ScrollToPinned.propTypes = {
    children: PropTypes.any
};
